/*
 * action types
 */
export const CURRENT_LESSON_PAGE = 'CURRENT_LESSON_PAGE'

/*
 * action creators
 */

export default function currentLessonPageAction(pageIndex) {
  return {
    payload: pageIndex,
    type: CURRENT_LESSON_PAGE,
  }
}
